import React from 'react';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const painPoints = [<span key="1" data-id="element-195">
      Envías mensajes y él <strong data-id="element-196">tarda horas (o días)</strong> en responder… o
      simplemente <em data-id="element-197">te ignora</em>
    </span>, <span key="2" data-id="element-198">
      Sientes que eres tú quien <strong data-id="element-199">siempre inicia</strong> la conversación
    </span>, <span key="3" data-id="element-200">
      Todo empieza con química… pero luego{' '}
      <strong data-id="element-201">se enfría sin explicación</strong>
    </span>, <span key="4" data-id="element-202">
      Te esfuerzas demasiado y recibes <strong data-id="element-203">muy poco a cambio</strong>
    </span>, <span key="5" data-id="element-204">
      No sabes <strong data-id="element-205">qué decir</strong> para mantener su interés
    </span>, <span key="6" data-id="element-206">
      Estás cansada de sentirte <em data-id="element-207">una opción</em> y no{' '}
      <strong data-id="element-208">una prioridad</strong>
    </span>];
  return <section className="py-12 md:py-16 bg-[#1f1f35]" data-id="element-209">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-211">
          <img src="https://cdn.magicpatterns.com/uploads/ntaMrf5NnBfBGmipZBtFmq/ChatGPT_Image_19_mar_2026,_00_07_04.png" alt="Sin mensajes magnéticos vs Con mensajes magnéticos" className="w-full max-w-2xl mx-auto rounded-2xl shadow-2xl mb-8" data-id="element-212" />
          <h2 className="text-3xl xl:text-4xl font-bold text-white mb-4" data-id="element-213">
            Este Recurso Es Para Ti Si
          </h2>
          <div className="w-24 h-1 bg-rose-600 mx-auto rounded-full" data-id="element-214" />
          <div className="space-y-4 mt-8" data-id="element-215">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start p-4 bg-white/5 rounded-xl border border-white/10 border-l-4 border-l-red-500 transition-all" data-id="element-216">
                <div className="flex-shrink-0 mt-1" data-id="element-217">
                  <div className="w-6 h-6 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-218">
                    <XIcon className="w-4 h-4 text-red-400" strokeWidth={3} data-id="element-219" />
                  </div>
                </div>
                <p className="ml-4 text-lg font-medium text-gray-200" data-id="element-220">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}